import { ReactNode } from "react";
import { cn } from "../lib/utils";

interface Props {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
  /** Optional count rendered after the label, e.g. "Active (3)". */
  count?: number;
  className?: string;
  title?: string;
}

/**
 * Outlined toggle chip for list filters (Smartlead's "All Leads (15) · Active
 * (0) · Replied (0)" row): grey outline at rest, brand outline + brand text +
 * faint brand tint when active.
 */
export default function FilterChip({ active, onClick, children, count, className, title }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-pressed={active}
      className={cn(
        "inline-flex items-center gap-1 px-3 py-1.5 rounded-lg border text-xs font-medium transition-colors whitespace-nowrap",
        active
          ? "border-primary text-primary bg-primary-soft"
          : "border-border text-muted-foreground bg-surface hover:text-foreground hover:border-neutral-border",
        className,
      )}
    >
      {children}
      {count !== undefined && <span className={active ? "opacity-80" : "opacity-70"}>({count})</span>}
    </button>
  );
}
